import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useArchiveGiftCardMutation = createMutationHook(GiftCardsApiClient.archiveGiftCard, {
  mutationKey: ['archiveGiftCard'],
})
